import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { FaHome, FaLock, FaEnvelope, FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';

const AdminLogin = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  // Si ya está autenticado, redirigir al dashboard
  React.useEffect(() => {
    if (isAuthenticated) navigate('/admin12/dashboard', { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await login(data.email, data.password);
      toast.success('Bienvenido al panel de administración');
      navigate('/admin12/dashboard');
    } catch (error) {
      const msg = error.response?.data?.message || 'Credenciales inválidas';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__card">
        <div className="admin-login__logo">
          <div className="admin-login__logo-icon"><FaHome /></div>
          <div>
            <div className="admin-login__logo-name">Casa Bonita</div>
            <div className="admin-login__logo-sub">Panel de Administración</div>
          </div>
        </div>

        <div className="admin-login__header">
          <FaLock className="admin-login__lock" />
          <h2>Acceso Restringido</h2>
          <p>Ingresa tus credenciales de administrador</p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-group">
            <label>
              <FaEnvelope /> Email
            </label>
            <input
              type="email"
              {...register('email', { required: 'El email es requerido' })}
              placeholder="correo@ejemplo.com"
              autoComplete="email"
              className={errors.email ? 'error' : ''}
            />
            {errors.email && <span className="form-error">{errors.email.message}</span>}
          </div>

          <div className="form-group">
            <label>
              <FaLock /> Contraseña
            </label>
            <div className="password-field">
              <input
                type={showPass ? 'text' : 'password'}
                {...register('password', { required: 'La contraseña es requerida' })}
                placeholder="••••••••"
                autoComplete="current-password"
                className={errors.password ? 'error' : ''}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPass(!showPass)}
              >
                {showPass ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {errors.password && <span className="form-error">{errors.password.message}</span>}
          </div>

          <button
            type="submit"
            className="btn btn--navy btn--full btn--lg"
            disabled={loading}
          >
            {loading ? <><span className="btn-spinner" /> Verificando...</> : 'Ingresar'}
          </button>
        </form>

        <div className="admin-login__back">
          <a href="/">← Volver al sitio principal</a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
